import { render } from "./LoaderPopup.vue?vue&type=template&id=38b35d18&scoped=true"
import script from "./LoaderPopup.vue?vue&type=script&lang=js"
export * from "./LoaderPopup.vue?vue&type=script&lang=js"

import "./LoaderPopup.vue?vue&type=style&index=0&id=38b35d18&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\ASRHAVELI\\attendance\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b35d18"]])

export default __exports__